import { getIdToken, isAuthBypassed, refreshTokens } from "./auth";

const API_BASE = (import.meta.env.VITE_API_BASE_URL ?? "/api").replace(
  /\/$/,
  "",
);

type ApiResponse<T> =
  | { success: true; data: T }
  | { success: false; error: string };

/** API へのリクエスト共通処理（Cognito JWT を Authorization ヘッダに付与） */
export const apiFetch = async <T>(
  path: string,
  init?: RequestInit,
): Promise<T> => {
  const url = `${API_BASE}${path.startsWith("/") ? path : `/${path}`}`;
  const headers = new Headers(init?.headers);
  headers.set("Content-Type", "application/json");

  if (!isAuthBypassed()) {
    let token = getIdToken();
    if (!token) {
      const refreshed = await refreshTokens();
      if (refreshed) token = getIdToken();
    }
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
  }

  const res = await fetch(url, { ...init, headers });
  const json = (await res.json()) as ApiResponse<T>;

  if (!res.ok || !json.success) {
    const errorMsg = json.success ? "Unknown error" : json.error;
    throw new Error(errorMsg);
  }
  return json.data;
};
